module.exports = __webpack_public_path__ + "catalog/items/livingroom/Grandpiano/Grandpiano.svg";